module.exports = __webpack_public_path__ + "static/media/mark-attendance-icon.28ca8cc0.png";